'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Returns true if the provided key is a CSS variable
 */
function isCSSVariable(key) {
  return key.startsWith("--");
}

exports.isCSSVariable = isCSSVariable;
